import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../environments/environment';
import {SharedService} from '../../core/services/store/shared-store/shared-storage.service';
import {CMSConditions} from '../../shared/models';


function titleCase(str) {
    return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
            return word.replace(word[0], word[0].toUpperCase());
        })
        .join(' ');
}

export enum CHANNELS {
    DEFAULT = 0,
    SMS = 6,
    USSD = 7,
    WHATSAPP = 8,
    TELEGRAM = 9,
    FACEBOOK = 10,
    RAAS = 42,
    ABC = 13,
    GBM = 12,
    WEBCHAT = 11,
    DYNAMIC_API = 14
}

@Pipe({
    name: 'apiUrlPipe'
})
export class ApiUrlPipe implements PipeTransform {
    constructor(private sharedService: SharedService) {}

    transform(value: any, ...args: any[]): any {
        let url: string = environment.dynamicApiUrlSandbox;
        if (this.sharedService.isProdEnv) {
            url = environment.dynamicApiUrlProduction;
        }
        return `${url}/${value}`;
    }
}


@Pipe({name: 'renameProperty'})
export class RenamePropertyPipe implements PipeTransform {
    transform(property: any): string {
        const newProperty = property
            .replace(/([a-z])([A-Z])/g, `$1 $2`)
            .replace('-', ' ');
        return titleCase(newProperty)
            .replace(/(^|\s)api(\s|$)/i, '$1API$2');
    }
}



@Pipe({name: 'ChannelName'})
export class ChannelNamePipe implements PipeTransform {
    transform(channelId: number): string {
        switch (channelId) {
            case CHANNELS.DEFAULT:
            case CHANNELS.DYNAMIC_API:
                return 'DEFAULT';
            case CHANNELS.SMS:
                return 'SMS';
            case CHANNELS.USSD:
                return 'USSD';
            case CHANNELS.WHATSAPP:
                return 'WHATSAPP';
            case CHANNELS.TELEGRAM:
                return 'TELEGRAM';
            case CHANNELS.FACEBOOK:
                return 'FACEBOOK';
            case CHANNELS.RAAS:
                return 'RAAS';
            case CHANNELS.ABC:
                return 'ABC';
            case CHANNELS.GBM:
                return 'GBM';
            case CHANNELS.WEBCHAT:
                return 'WEBCHAT';
        }

    }
}


@Pipe({name: 'buildCMSConditions'})
export class BuildCMSConditionsPipe implements PipeTransform {
    transform(field: string, channelId: number): CMSConditions {
        return {
            channelId: channelId,
            field: field,
            size: '20',
            type: 'routing'
        };
    }
}

@Pipe({name: 'getErrorMessage'})
export class GetErrorMessagePipe implements PipeTransform {
    transform(key: string, channelId: number, routeList: any[], currentRoute: any, currentIndex: number): string {
        switch (key) {
            case 'id':
                if (!currentRoute.routeId && currentRoute.routeId === '') {
                    return 'Field is required';
                }
                const existingId = routeList.filter(
                    (elt, index) => elt.routeId === currentRoute.routeId && index !== currentIndex
                );
                if (existingId.length > 0) {
                    return 'Router with same Integration ID already exists';
                }
                break;
            case 'flow':
                return 'Please select a value';
            case 'step':
                if (!currentRoute.flowName) {
                    return 'Please select a flow first';
                }
                return 'Please select a value';
            case 'integration':
                return 'Field is required';
            default:
                return 'Please select a value';
        }
    }
}

@Pipe({name: 'placeholderDisplay'})
export class PlaceholderDisplayPipe implements PipeTransform {
    transform(channelId: number, prefix: string= 'Enter'): string {
        switch (channelId) {
            case CHANNELS.USSD:
                return `${prefix} Short Code`;
            case CHANNELS.ABC:
                return `${prefix} Business ID`;
            default:
                return `${prefix} API ID`;
        }
    }
}

@Pipe({name: 'channelIntegration', pure: true})
export class ChannelIntegrationPipe implements PipeTransform {
    transform(channelId: number, integrationList: any): boolean {
        if (!channelId) {
            return false;
        }
        return integrationList ? integrationList.some(integrationData => integrationData.channelTypeId === channelId) : false;
    }
}
